module.exports = __webpack_public_path__ + "static/media/homeImg.ba5afcf5.svg";